import Bottle from 'bottlejs';
import spottingGroupDrilldownContainerFactory from './SpottingGroupDrilldownContainer';
import spottingGroupDrilldownViewFactory from './SpottingGroupDrilldownView';
import spottingGroupDrilldownAddGroupFactory from './SpottingGroupDrilldownAddKeywordsContainer';
import spottingGroupDrildownAddHelpFactory from './SpottingGroupDrilldownAddHelp';
import spottingGroupDrilldownData from './SpottingGroupDrilldownData';
import spottingGroupData from '../SpottingGroup/SpottingGroupData';
import spottingGroupDrilldownConstants from './SpottingGroupDrilldownConstants';

export default () => {
  const spottingGroupDrilldownBottle = new Bottle();
  spottingGroupData(spottingGroupDrilldownBottle);
  spottingGroupDrilldownConstants(spottingGroupDrilldownBottle);
  spottingGroupDrilldownContainerFactory(spottingGroupDrilldownBottle);
  spottingGroupDrilldownViewFactory(spottingGroupDrilldownBottle);
  spottingGroupDrilldownData(spottingGroupDrilldownBottle);
  spottingGroupDrilldownAddGroupFactory(spottingGroupDrilldownBottle);
  spottingGroupDrildownAddHelpFactory(spottingGroupDrilldownBottle);
  return spottingGroupDrilldownBottle;
};
